import React from "react";
import styles from "../../assets/css/modules/health-store/health-store.css";
import gpStyles from "../../assets/css/modules/health-support/gp-appointments-247.css";
import Store from "./../../content/Store";
import CenteredContentHero from "../healthStore/CenteredContentHero";
import { Paths } from "../../constants/UrlConstants";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import HelpSection from "../shared/HelpSection";
import  MskSection  from "../shared/MskSection";
import Contentify from "../../content/Contentify";
import { Layouts } from "../../constants/Constants";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";
import PromoImageCard from "../shared/PromoImageCard";


export const mapStateToGPAppointments247 = (state) => {
  const currentPolicy = state.policyReducer && state.policyReducer.selectedPolicy;
  const isInternationalOrSaga =
    currentPolicy && (currentPolicy.IsSaga || currentPolicy.IsInternational);
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const isChildOnly = currentPolicy?.IsChildOnlyPolicy;
  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    currentPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);

  return {
    isLapsed,
    isInternationalOrSaga,
    isAgeAbove18,
    layout: state.layoutReducer && state.layoutReducer.layout,
    isSMEModular: currentPolicy && currentPolicy.IsSMEModular,
    isLargeCorporate: currentPolicy && currentPolicy.IsLargeCorporate,
    isEDCA: currentPolicy && currentPolicy.IsEDCA,
    isIndividual :currentPolicy && currentPolicy.IsIndividual,
    isChildOnly: isChildOnly
  };
};

export const onButtonClick = (uri) => {
  window.open(uri);
};

const gp247Content = (props) => {
  var heroContent = props.isEDCA
    ? {
      HomeHeroBGSrc: props.content.EDCAHomeHeroBGSrc,
      HomeHeroBGSrcMobile: props.content.EDCAHomeHeroBGSrcMobile,
      HomeHeroBGSrcTablet: props.content.EDCAHomeHeroBGSrcTablet,
      Heading: props.content.Heading,
      Description: props.content.EDCADescription,
      Setupthisservice:props.content.Setupthisservice,
      BookanAppointment:props.content.BookanAppointment,
      Layout:props.layout
    }:{
      HomeHeroBGSrc: props.content.EDCAHomeHeroBGSrc,
      HomeHeroBGSrcMobile: props.content.EDCAHomeHeroBGSrcMobile,
      HomeHeroBGSrcTablet: props.content.EDCAHomeHeroBGSrcTablet,
      Heading: props.content.Heading,
      Description: props.isLargeCorporate? props.content.LargeDescription: props.content.OthersDescription,
      Setupthisservice:props.content.Setupthisservice,
      BookanAppointment:props.content.BookanAppointment,
      Layout:props.layout
    };
     
  var helpsetContent =  props.isLargeCorporate || props.isEDCA ? 
                        props.content.LargeCorporateHelpSet : 
                        props.isIndividual ? props.content.IndiviualHelpSet: 
                        props.content.OtherHeadeSet ;
  
  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className={styles.containerShadow}>
              <CenteredContentHero
                Content={heroContent}
                ShowGp={false}
                onButtonClick={
                  (props.isSMEModular || props.isLargeCorporate) &&
                  (() => onButtonClick(props.content.ExternalLinkTo))
                }
                UniqueKey="GPwhiteBox"
              /> 
              {/* {!props.isLargeCorporate && !props.isEDCA ? (
                <section className={styles.sectionSpacing}>
                  <h2 data-how-to-register-header className={gpStyles.heading}>
                    {props.content.HowToRegisterHeading}
                  </h2>
                  <div
                    data-how-to-register-list
                    className={gpStyles.sectionList}
                  >
                    {props.content.HowToRegisterSection}
                  </div>
                </section>
              ) : null} */}

              <section
                className={styles.sectionSpacing + " " + gpStyles.heading}
              >
                <h2 data-how-it-works-header>
                  {props.content.HowItWorksSectionSubheading}
                </h2>
                <div data-how-it-works-list className={gpStyles.sectionList}>
                  {props.isEDCA ? (
                    <React.Fragment>
                      {props.content.EDCAHowItWorksContent}
                      {/* {props.content.EDCAUsageNote}s */}
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        {props.isLargeCorporate? props.content.LargeHowItWorksContent: props.content.OthersHowItWorksContent}
                        {/* {props.content.HowItWorksFindOutMore} */}
                        {/* {props.content.usageNote} */}
                      </React.Fragment>
                    )}
                </div>
              </section>
              <section className={styles.sectionSpacingHelpSection}>                
               {props.layout === Layouts.MOL ? props.content.MolMoreService.Appointment : props.content.HolMoreService.Appointment}                              
              </section>      
              <section className={styles.sectionSpacingHelpSection}>                
               {props.layout === Layouts.MOL ? props.content.MolMoreService.Prescriptions : props.content.HolMoreService.Prescriptions}                              
              </section>
              <section className={styles.sectionSpacingHelpSection}>
                <HelpSection
                  HeadingLinkTo={Paths.Help}
                  HeadingLinkText={Store.GeneralPages.GPHelpHeadingLinkText}
                  MoreHelpLinkTo={Paths.Help}
                  MoreHelpLinkText={Store.GeneralPages.GPMoreHelpLinkText}
                  HelpSet={helpsetContent}
                  // Healthsupportline="Healthsupportline"
                />
              </section>
              <section className={styles.sectionSpacingHelpSection}>
                <div className={styles.importantSection}>
                  {props.content.Importantinfo}  <br/>
                  {props.content.ImportantNoteAvailabilityText}<br/>
                  {props.content.ImportantNotePrescriptionsText}<br/>
                  {props.content.ImportantNotereferralsText}<br/>
                </div>
              </section>  
              <section className={styles.sectionSpacing}>
                  {!props.isLapsed && (props.isAgeAbove18? <MskSection accessPage={Paths.GPAppointments247} UniqueKey="GPSection"/>:
                  (<PromoImageCard
                  ImgSrc={props.content.AskMedExpert.IconSrc}
                  ImgSrcMobile={props.content.AskMedExpert.IconSrcMobile}
                  Heading={props.content.AskMedExpert.Heading}
                  Description={props.content.AskMedExpert.Description}
                  LinkText={props.content.AskMedExpert.LinkText}
                  LinkTo={props.content.AskMedExpert.LinkTo}
                  LeftImage
                />))}
                </section>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export const GPAppointments247 = function (props) {
  return props.isInternationalOrSaga || props.isLapsed || props.isChildOnly ? (
    <Redirect to={Paths.NotFound} />
  ) : (
      gp247Content(props)
    );
};

GPAppointments247.content = {
  ...Store.GPAppointments247,
  ...Store.Home.Cards};

export default connect(mapStateToGPAppointments247)(
  Contentify(GPAppointments247)
);
